import React, { Component } from "react";
import { Map, Polyline, GoogleApiWrapper } from "google-maps-react";
import axios from "axios";

class MapAPI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      triangleCoords: [],
      initial: {
        lat: 37.32,
        lng: 127.09
      },
      loading: false
    }
  }
  async getRecords() {
    let recordResult = this.props.result;
    let tmpArray = [];
    if(recordResult == ''){
      console.log('recordResult 없음');
      return;
    }
    recordResult.map((item, key) => {
      tmpArray = [...tmpArray, { lat: item.latitude, lng: item.longitude }];
    });
    this.setState({
      triangleCoords: tmpArray,
      initial: {
        lat: recordResult[0].latitude,
        lng: recordResult[0].longitude
      },
      loading: true
    });
  }
  async componentDidMount() {
    await this.getRecords();
    console.log('componentDidMount!!! -->>',this.state.initial);
  }
  render() {
    if (this.state.loading) {
      return (
        <Map google={this.props.google}
          style={{ width: '100%', height: '100%', position: 'relative' }}
          className={'map'}
          zoom={18}
          initialCenter={{ lat: this.state.initial.lat, lng: this.state.initial.lng }}
        >
          <Polyline
            path={this.state.triangleCoords}
            strokeColor="#0000FF"
            strokeOpacity={0.6}
            strokeWeight={6} />
        </Map >
      );
    } else {
      return (
        <div>
          로딩중입니다.
        </div>
      );
    }

  }
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyCHzjjQofo1wpJJD2VN4qzJs3KkWSjLZDc"
})(MapAPI);